
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import numberComma from 'vux/src/tools/number/comma.js'
import Cell from 'vux/src/components/cell/index.vue'


export default {
components: {
XHeader,
XInput,
Group,
Cell
},
data () {
return {
currentIptView: '100',
jpyValue: 100,
currentInputEl: 'JPY',
rate: {
REFUND: 0,
CNY: 0,
USD: 0,
HKD: 0
},
eqFlag: true
};
},
created () {
this.loadData();
},
computed: {
jpyValueView () {
return numberComma((this.jpyValue || 0).toFixed(2));
},
cnyValue () {
return numberComma(((this.jpyValue || 0) * this.rate.CNY).toFixed(2));
},
usdValue () {
return numberComma(((this.jpyValue || 0) * this.rate.USD).toFixed(2));
},
hkdValue () {
return numberComma(((this.jpyValue || 0) * this.rate.HKD).toFixed(2));
},
refundValue () {
return numberComma(((this.jpyValue || 0) * this.rate.CNY * this.rate.REFUND).toFixed(2));
}
},
methods: {
loadData () {
const self = this;
self.$http.get('./static/phpapi/exchange.php', {params: {type: 'rate'}})
.then((resp) => {
self.rate = resp.data.rate;
})
.catch((err) => console.error(err));
},
handleKeyBoard (key) {
const self = this;
let v = 0;
switch (key) {
case 'B':
if (self.currentIptView.length > 0) {
self.currentIptView = self.currentIptView.substring(0, self.currentIptView.length - 1);
}
break;

case '.':
var viewParts = self.currentIptView.split('+');
viewParts = viewParts[viewParts.length - 1].split('-');
if (viewParts[viewParts.length - 1].indexOf('.') === -1) {
self.currentIptView += '.';
}
break;

case '=':
case '+':
case '-':
v = eval(self.currentIptView);
self.currentIptView = v.toString();
if (key === '=') {
self.eqFlag = true;
} else {
self.eqFlag = false;
self.currentIptView += key;
}
break;

default:
if (self.eqFlag) {
self.currentIptView = '';
self.eqFlag = false;
}
self.currentIptView += key;
break;
}
if (self.currentIptView) {
self.jpyValue = eval(self.currentIptView);
if (self.currentInputEl !== 'JPY') {
self.jpyValue = self.jpyValue / self.rate[self.currentInputEl];
}
} else {
self.jpyValue = 0;
}
},
handleFocues (type) {
this.currentInputEl = type;
this.eqFlag = true;
switch (type) {
case 'JPY':
this.currentIptView = this.jpyValueView;
break;

case 'CNY':
this.currentIptView = this.cnyValue;
break;
}
}
}
};



// WEBPACK FOOTER //
// ./src/components/exChange/ExChange.vue